<template>
  <el-dialog style="width: 1000px;margin:0 auto;font-size:36px;" title="在线支付" :visible.sync="visibleModel" @close="handleCancel">
    <!-- todo -->
    <!-- <div style="text-align:center;font-size:12px;">请选择支付方式</div> -->
    <div style="height: 220px;">
      
      <div v-show="!weixinLoading&&!alipayLoading" style='justify-content: center;display: flex;align-items: center;'>
        <div @click="alipayOrderAdd" class='order' style=''>
          <img class='payImg' src="../../static/img/alipay.png" alt="" >
          <span>支付宝支付</span>
        </div>
         <!-- todo -->
        <!-- <div @click="weixinOrderAdd" class='order'>
          <img class='payImg' src="../../static/img/wechat.png" alt="" >
          <span>微信支付</span>
        </div> -->
        
        <!-- <div class='space'>
          <img @click="alipayOrderAdd" src="../../static/img/alipay.png" alt="" style='width:30px;height:30px;'>
          <el-button type="primary" @click="alipayOrderAdd">支付宝</el-button>
        </div>
        <div class='space'>
          <img @click="weixinOrderAdd" src="../../static/img/wechat.png" alt="" style='width:30px;height:30px;'>
          <el-button type="success" @click="weixinOrderAdd">微信</el-button>
        </div> -->
        
      </div>
      <div v-if="alipayLoading">
        <div v-loading="true" element-loading-text="支付中" style="height: 100px;"></div>
        <div style="text-align: center">
          <el-button type="text" style="margin-right: 10px;" @click="handleOk">支付完成</el-button>
          <a style="color: #999;cursor: pointer" @click="handleCancel">支付失败</a>
        </div>
      </div>
      <div v-if="weixinLoading" style="text-align: center">
        <img style="width: 200px; height: 200px;" :src="codeImageUrl">
        <div style="text-align: center">
          <el-button type="text" style="margin-right: 10px;" @click="handleOk">支付完成</el-button>
          <a style="color: #999; cursor: pointer" @click="handleCancel">支付失败</a>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "PayDialog",
  components: {},
  props: {
    signId: {
      type: String | Number,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      weixinLoading: false,
      alipayLoading: false,
      codeImageUrl:
        "http://sign.xn--fjq0sg8h2zkivvwsonptcv2b.com/api//usr/java/yinxie/pic/2019041518055228756150.png",
      isPayT: {}
    };
  },
  watch: {
    singnId(value) {
      let that = this;
      if (value) {
        //          that.getOrder();
      }
    }
  },
  methods: {
    alipayOrderAdd() {
      let that = this;
      that.alipayLoading = true;
      window.open(
        window.Global.domain + "/pay/ali/addOrder?signId=" + that.signId
      );
    },
    weixinOrderAdd() {
      let that = this;
      that.weixinLoading = true;
      window.Global.post(
        "/pay/wx/addOrder",
        {
          signId: that.signId
        },
        rs => {
          if (rs.data.status == 200) {
            console.log(rs.data.result);
            that.codeImageUrl = rs.data.result.imageUrl;
            that.checkPayed();
            console.log(that.codeImageUrl);
          } else {
            that.weixinLoading = false;
            self.$message.error(rs.data.message);
          }
        }
      );
    },
    checkPayed() {
      let that = this;
      that.isPayT = setInterval(() => {
        window.Global.post(
          "/pay/isPay",
          {
            signId: that.signId
          },
          rs => {
            if (rs.data.status == 200) {
              //支付成功
              that.handleOk();
              // this.$emit("payWin","true");
              // that.$router.push({name:"indexSign"})
            } else {
              //继续等待
            }
          }
        );
      }, 2000);
    },
    handleCancel() {
      clearInterval(this.isPayT); //清除轮询
      this.$emit("payCancel");
      window.location.reload()
    },
    handleOk() {
      clearInterval(this.isPayT); //清除轮询
      this.$emit("payDone");
      window.location.reload()
    }
  },
  computed: {
    visibleModel: {
      get: function() {
        return this.visible;
      },
      set: function() {}
    }
  }
};
</script>

<style lang="less" scoped>
.el-button{
  width: 100px;
  height: 30px;
  padding: 0;
  span{
  line-height: 30px;
  }
  
}
.space{
  padding: 10px 0;
}
.el-dialog .el-dialog__body{
  padding-top:0; 
  
}
.order{
  border:1px solid #eee;
  width:150px;
  height:65px;
  line-height:60px;
  margin:30px 15px;
  border-radius: 8px;
  text-align: center;
}
.order .payImg{
  width:40px;
  height:40px;
  margin-top:10px
}
</style>


// WEBPACK FOOTER //
// src/components/PayDialog.vue